'use client'

import { styled } from '@mui/material'
import { PageLayout } from '@biolumina/ui/containers/pageLayout/pageLayout'

export const StyledPageLayout = styled(PageLayout)(({ theme }) => ({
  background: theme.palette.background.default,
  
  '.spacing': {
    margin: theme.spacing(5),
  },
  '.resource-cta': {
    minWidth: '250px',
  },

  '.chart-img': {
    maxWidth: "300px",
    margin: theme.spacing(3, 'auto'),
    [theme.breakpoints.up('sm')]: {
      maxWidth: "800px",
      margin: theme.spacing(4, 'auto'),
    },
  }
}))
